module.exports = "<!-- Intentionally empty -->"


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/authentication/sso-handler/sso-handler.component.html
// module id = ../../../../../src/app/authentication/sso-handler/sso-handler.component.html
// module chunks = main